var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Page 1"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinejoin":"round","key":3},React.createElement("g",{"id":"Letter-–-Scrolled-further","transform":"translate(-882.000000, -635.000000)","stroke":"#7ED321"},React.createElement("g",{"id":"Page-1","transform":"translate(883.000000, 636.000000)"},[React.createElement("polygon",{"id":"Stroke-1","points":"0.339285714 17.4821429 17.4821429 17.4821429 17.4821429 0.339285714 0.339285714 0.339285714","key":0}),React.createElement("polyline",{"id":"Stroke-3","strokeLinecap":"round","points":"3.23214286 5.60714286 4.58928571 6.96428571 7.98214286 3.57142857","key":1}),React.createElement("polyline",{"id":"Stroke-4","strokeLinecap":"round","points":"3.23214286 12.0535714 4.58928571 13.4107143 7.98214286 10.0178571","key":2}),React.createElement("path",{"d":"M9.33928571,6.625 L14.7678571,6.625","id":"Stroke-5","strokeLinecap":"round","key":3}),React.createElement("path",{"d":"M9.33928571,12.7321429 L14.7678571,12.7321429","id":"Stroke-6","strokeLinecap":"round","key":4})])))]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"19px","height":"19px","viewBox":"0 0 19 19","version":"1.1"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ../node_modules/svg-react-loader/lib/loader.js?name=Icon!./client/assets/icons/pledge-icon.svg
// module id = 1294
// module chunks = 0